import React, { useState } from "react";
import classes from "../../Landing/Landing.module.scss";
import { Link } from "react-router-dom";


function ServiceCard() {
const [showAll, setShowAll] = useState(false);

const allServices = [
    {
      id: 1,
      title: 'Braces and Aligners',
      image: 'https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1766376115/braces_lwjlte.png',
      alt: 'Dental braces and aligners - teeth straightening treatment at Mahi Dental Clinic Gandhinagar',
      path: "/our-services/braces-aligners"
    },
    {
      id: 2,
      title: 'Painless Root Canal',
      image: 'https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1766376283/rootcanal2_ezlv27.png',
      alt: 'Painless root canal treatment - advanced dental procedure at Mahi Dental Clinic',
      path: "/our-services/painless-root-canal"
    },
    {
      id: 3,
      title: 'Dental Implant',
      image: 'https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1766376265/dentalimplant1_iyswd2.png',
      alt: 'Dental implant tooth replacement solution at Mahi Dental Clinic Gandhinagar',
    path: "/our-services/dental-implant"
    },
    {
      id: 4,
      title: 'Denture',
      image: 'https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1766379978/denture1_ninka1.png',
      alt: 'Complete and partial denture solutions - missing teeth replacement at Mahi Dental Clinic',
      path: "/our-services/denture"
    },
    {
      id: 5,
      title: 'Crowns & Bridges',
      image: 'https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1766382389/dc1_sunlf0.png',
      alt: 'Dental crowns and bridges - tooth restoration treatment at Mahi Dental Clinic',
       path: "/our-services/crowns-bridges"
    },
    {
      id: 6,
      title: 'Full Mouth Reconstruction',
      image: 'https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1766382437/fmr1_kv2ftk.png',
      alt: 'Full mouth reconstruction - comprehensive dental rehabilitation at Mahi Dental Clinic',
      path: "/our-services/full-mouth-reconstruction"
    },
    {
      id: 7,
      title: 'Children Dentistry',
      image: 'https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1766382654/cd1_xzwgyz.png',
      alt: 'Pediatric dentistry - child dental care services at Mahi Dental Clinic Gandhinagar',
       path: "/our-services/children-dentistry"
    },
    {
      id: 8,
      title: 'Teeth Whitening',
      image: 'https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1766382430/vc3_zojnk2.png',
      alt: 'Professional teeth whitening - bright smile treatment at Mahi Dental Clinic',
      path: "/our-services/teeth-whitening"
    },
    {
      id: 9,
      title: 'Veneer and Componeers',
      image: 'https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1766382406/vc1_ljvqte.png',
      alt: 'Dental veneers and componeers - cosmetic smile enhancement at Mahi Dental Clinic',
       path: "/our-services/veneer-componeers"
    },
    {
      id: 10,
      title: 'TMJ Disorder',
      image: 'https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1766393098/Gemini_Generated_Image_uu0k9nuu0k9nuu0k_b372hm.png',
      alt: 'TMJ disorder treatment - jaw pain relief at Mahi Dental Clinic',
      path: "/our-services/tmj-disorder"
    },
    {
      id: 11,
      title: 'Gum disease Treatment',
      image: 'https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1766316555/11_dq1ua4.png',
      alt: 'Gum disease treatment - periodontal care at Mahi Dental Clinic Gandhinagar',
       path: "/our-services/gum-disease"
    },
    {
      id: 12,
      title: 'Gum depigmentation and Gum Contouring',
      image: 'https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1766315721/gdc1_j5lvlz.png',
      alt: 'Gum depigmentation and contouring - smile design at Mahi Dental Clinic',
      path: "/our-services/gum-depigmentation-and-gum-contouring"
    },
    {
      id: 13,
      title: 'Fillings, Inlays and Onlays',
      image: 'https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1766384905/inon_ze5wcc.png',
      alt: 'Dental fillings, inlays and onlays - cavity restoration at Mahi Dental Clinic',
       path: "/our-services/fillings-inlays-and-onlays"
    },
    {
      id: 14,
      title: 'Jaw Bone Regeneration',
      image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=400&h=300&fit=crop',
      alt: 'Jaw bone regeneration - bone grafting procedure at Mahi Dental Clinic',
      path: "/our-services/jaw-bone-regenration"
    },
    {
      id: 15,
      title: 'Gum repositioning Surgery',
      image: 'https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1766313669/ggs12_eobqtm.png',
      alt: 'Gum repositioning surgery - gum recession treatment at Mahi Dental Clinic',
      path: "/our-services/gum-repositioning-surgery"
    },
    {
      id: 16,
      title: 'Teeth Straightening',
      image: 'https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1766312592/teeth2_lvgnnr.png',
      alt: 'Teeth straightening - orthodontic treatment at Mahi Dental Clinic Gandhinagar',
      path: "/our-services/teeth-straightening"
    },
    {
      id: 17,
      title: 'Jaw Growth Guidance',
      image: 'https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1766312019/Gemini_Generated_Image_m7u8dvm7u8dvm7u8_wstvtb.png',
      alt: 'Jaw growth guidance - pediatric orthodontics at Mahi Dental Clinic',
      path: "/our-services/jaw-growth-guidance",
    },
    {
      id: 18,
      title: 'Orthognathic Surgery',
      image: 'https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1766311692/ort1_cc79gh.jpg',
      alt: 'Orthognathic surgery - corrective jaw surgery at Mahi Dental Clinic',
      path: "/our-services/orthognathic-surgery",
    },
    {
      id: 19,
      title: 'Flouride Treatment',
      image: 'https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1766313084/fl2_eikyhq.png',
      alt: 'Fluoride treatment - cavity prevention for children at Mahi Dental Clinic',
      path: "/our-services/flouride-treatment"
    },
    {
      id: 20,
      title: 'Preventive Sealants',
      image: 'https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1766309805/sea1_loytmj.png',
      alt: 'Preventive sealants - dental protection treatment at Mahi Dental Clinic',
      path: "/our-services/preventive-sealants",
    },
    {
      id: 21,
      title: 'Habit Breaking Appliances',
      image: 'https://res.cloudinary.com/dj7gzc2mb/image/upload/f_auto,q_auto/v1766310511/hba13_hjbd0y.png',
      alt: 'Habit breaking appliances - thumb sucking and nail biting treatment at Mahi Dental Clinic',
      path: "/our-services/habit-breaking-appliances"
    }
  ];

  const displayedServices = showAll ? allServices : allServices.slice(0, 10);

  return (
    <>
    <div className="bg-gray-100 px-6 py-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-gray-600 font-semibold mb-2 tracking-wide">Our Services</p>
          <h1 className="text-2xl md:text-5xl font-bold" style={{ color: '#88b121' }}>
            OUR DENTAL SERVICES
          </h1>
        </div>

        {/* Services Grid */}
     <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-12">
          {displayedServices.map((service) => (
            <Link
              key={service.id}
              to={service.path}
              className="bg-white rounded-sm shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer block"
            >
              <div className="h-32 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.alt}
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="p-3 text-center">
                <h3 className="text-gray-800 font-semibold text-xs">
                  {service.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
        {/* Toggle Button */}
        <div className="text-center">
          <button
            onClick={() => setShowAll(!showAll)}
            className="px-8 py-3 bg-blue-900 text-white font-semibold rounded-full hover:opacity-90 transition-opacity duration-300"
          >
            {showAll ? 'View Less Services' : 'View All Services'}
          </button>
        </div>
      </div>
    </div>
    </>
  );
}

export default ServiceCard;
